<a *ngIf="!isImage() && !isPdf()" href="{{File_Storage_URL}}{{file}}" target="_blank" [matTooltip]="getFileName()">
	<fa-icon [icon]="['fas', getFileExtension()]" class="main-icon"></fa-icon>
</a>
<a *ngIf="isImage() || isPdf()" [routerLink]="['/'+topbar+'/file-preview']" [queryParams]="{file:file}" target="_blank"
	[matTooltip]="getFileName()">
	<fa-icon [icon]="['fas', getFileExtension()]" class="main-icon"></fa-icon>
</a>